import { initApolloClient } from "./apolloClient";
import { GET_AUTH_USER } from "@/graphql/queries/user";
import { cookie } from "./cookie";
import { OTP_LOGIN } from "@/graphql/mutations/auth";
import jwt from "jsonwebtoken";
const TEN_MINUTES = 1000 * 60 * 10;
export const USER_JWT_EXPIRATION = "10m";
export function ServerOnly(cb) {
  return async function (ctx, done) {
    const { req } = ctx;
    const isCSRouting = !req || (req.url && req.url.startsWith("/_next/data"));
    if (isCSRouting) return cb ? cb(done) : done({});
  };
}
function verifyJwt(jwtToken) {
  try {
    return jwt.verify(jwtToken, process.env.NEXT_PUBLIC_SERVER_RUNTIME_SECRET);
  } catch (e) {
    return null;
  }
}

export function TokenResolver() {
  return async function (ctx) {
    ctx.authState = {
      ...(ctx.authState || {}),
    };

    try {
      const apolloClient = initApolloClient();
      const { otp } = ctx.query || {};
      if (otp) {
        await OtpResolver(ctx);
        return await RemoveOtpFromUrlResolver()(ctx);
      }
      const token =
        ctx.authState.token ||
        cookie.get(ctx, "webapp_token")?.replaceAll(`%22`, "");
      const userDataJwt =
        ctx.authState.user || verifyJwt(cookie.get(ctx, "user"));

      if (!token || token.length < 10) {
        ctx.res.setHeader("set-cookie", cookie.delete("webapp_token"));
        return {};
      }

      /**
       *  Skip Calling API if jwt is valid
       * */
      // NOTE: removing this logic because it is not handling the case when user fields are updated in the admin portal.
      // ie: if admin approve the company photo it does not get reflected immediately.
      // if (userDataJwt && token) {
      //   ctx.authState = { user: userDataJwt, token };
      //   return {};
      // }

      const { data } = await apolloClient.query({
        query: GET_AUTH_USER,
        context: { token },
        skip: !token,
      });

      ctx.authState = { user: data?.User?.get, token };
      /*
       * Signing a JWT that lives 10 minutes and setting a cookie
       * */
      const userJwt = jwt.sign(
        {
          ...ctx.authState.user,
          about: undefined,
        },
        process.env.NEXT_PUBLIC_SERVER_RUNTIME_SECRET,
        {
          expiresIn: USER_JWT_EXPIRATION,
        },
      );

      ctx.res.setHeader(
        "set-cookie",
        cookie.set("user", userJwt, "/", Date.now() + TEN_MINUTES),
      );
    } catch (e) {
      ctx.res.setHeader("set-cookie", cookie.delete("webapp_token"));
    }
  };
}

export function AuthResolver() {
  return async function (ctx) {
    const { token } = ctx.authState;
    if (!token || token.length < 10) {
      return ctx.redirect("/login?returnTo=" + encodeURIComponent(ctx.req.url));
    }
  };
}

async function OtpResolver(ctx) {
  const { otp } = ctx.query || {};
  const client = initApolloClient();
  const { data } = await client.mutate({
    mutation: OTP_LOGIN,
    variables: { pw: otp },
  });
  const { user, token } = data?.User?.loginOTP || {};
  const userJwt = jwt.sign(
    { ...user, about: undefined },
    process.env.NEXT_PUBLIC_SERVER_RUNTIME_SECRET,
    {
      expiresIn: USER_JWT_EXPIRATION,
    },
  );

  ctx.res.setHeader("set-cookie", [
    cookie.set(
      "webapp_token",
      `%22${token}%22`,
      "/",
      Date.now() + 1000 * 60 * 60 * 24 * 365,
    ),
    cookie.set("user", userJwt, "/", Date.now() + TEN_MINUTES),
  ]);
  ctx.authState = { user, token };
}
export function RemoveOtpFromUrlResolver() {
  return async (ctx) => {
    const { otp } = ctx.query || {};
    if (!otp || !ctx.authState?.user) return;
    let newUrl = ctx.req.url
      ?.replace(/otp=[0-9-a-z-A-Z]+/g, "")
      .replace("&&", "&");
    newUrl = newUrl
      .split("?")
      .filter((s) => s)
      .join("?");
    ctx.redirect(newUrl);
  };
}

export function redirect(url, ctx) {
  ctx.res.writeHead(307, {
    Location: url,
    "Content-Type": "text/html; charset=utf-8",
  });
  return ctx.res.end();
}
